import React from "react";
import { useOutletContext } from "react-router-dom";
import LegalHtmlPage from "../components/LegalHtmlPage";

export default function TermsPage() {
  const { isRtl, text } = useOutletContext();
  const title = isRtl ? text.Arabic15 : "Terms & Conditions";
  return <LegalHtmlPage title={title} htmlField="terms_and_conditions" />;
}
